export default "__VITE_ASSET__CMQf0JK3__"